import { FormFieldSchemaType, type FormStepSchema } from '@/types';
import { schemaFieldName } from '../schemaFieldName';
import { schemaStepName } from '../schemaStepName';

interface GenerateNewClaimStepPaymentContactFormSchemaParams {
  emailAddress?: string;
}

const { paymentDetails, notifications } = schemaFieldName;

let stepPaymentContactFormSchema: FormStepSchema = {
  name: schemaStepName.stepPaymentContact,
  title: 'Share your bank and contact details',
  titleShort: 'Bank and contact details',
  lastUpdated: Date.now(),
  form: {
    name: `${schemaStepName.stepPaymentContact}Form`,
    fields: [],
  },
};

function generateNewClaimStepPaymentContactFormSchema({
  emailAddress = 'unknown.traveller@email.com',
}: GenerateNewClaimStepPaymentContactFormSchemaParams = {}): FormStepSchema {
  const { form, ...otherSchemaProps } = stepPaymentContactFormSchema;
  stepPaymentContactFormSchema = {
    ...otherSchemaProps,
    lastUpdated: Date.now(),
    form: {
      name: form.name,
      fields: [
        {
          type: FormFieldSchemaType.Text,
          name: paymentDetails.accountName,
          title:
            'Where should we deposit the claim payment if your claim is approved?<br/>Enter your bank account details.',
          label: 'Account name',
          placeholder: 'Enter account name',
        },
        {
          type: FormFieldSchemaType.Tel,
          name: paymentDetails.bsb,
          label: 'BSB number',
          placeholder: 'Enter six-digit BSB number',
          minLength: 6,
          maxLength: 6,
          layoutOptions: {
            width: '1/2-inline',
          },
        },
        {
          type: FormFieldSchemaType.Tel,
          name: paymentDetails.accountNumber,
          label: 'Account number',
          placeholder: 'Enter six-to-10-digit account number',
          minLength: 6,
          maxLength: 10,
          layoutOptions: {
            width: '1/2-inline',
          },
        },
        {
          value: emailAddress,
          type: FormFieldSchemaType.Email,
          name: notifications.emailAddress,
          label: 'Enter email address',
          layoutOptions: {
            isVisuallyHidden: true,
          },
        },
        {
          type: FormFieldSchemaType.Tel,
          name: notifications.mobileNumber,
          label:
            "We may need to contact you about your claim. If you'd prefer to be contacted by phone, please provide your mobile number.",
          placeholder: 'Enter mobile number',
          isRequired: false,
          layoutOptions: {
            width: '1/2-block',
          },
        },
      ],
    },
  };

  return stepPaymentContactFormSchema;
}

function getNewClaimStepPaymentContactFormSchema() {
  if (!stepPaymentContactFormSchema.form.fields.length) {
    // Generate a new schema with all fields, if its empty!
    stepPaymentContactFormSchema = generateNewClaimStepPaymentContactFormSchema();
  }

  return stepPaymentContactFormSchema;
}

export { generateNewClaimStepPaymentContactFormSchema, getNewClaimStepPaymentContactFormSchema };

export type { GenerateNewClaimStepPaymentContactFormSchemaParams };
